// tslint:disable-next-line: no-submodule-imports
import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CLOSE_CONTEXT_MENU } from '../actions/ContextMenu';
import { globals } from '../utils/globals';
import * as Styles from './ContextMenuOverlay.scss';
import ContextMenuItem from './widgets/items/ContextMenuItem';
const CONTEXT_MENU_WIDTH = 300;
const CONTEXT_MENU_HEIGHT = 300;
const WINDOW_PADDING = 24;
export const CONTEXT_MENU_OVERLAY_ID = "contextMenuOverlay";
export const CONTEXT_MENU_HOVER_BUTTON_ID = "contextMenuHoverButton";
function computeStyle(xOffset, yOffset, width = CONTEXT_MENU_WIDTH, height = CONTEXT_MENU_HEIGHT) {
    const styles = {
        left: `${xOffset}px`,
        top: `${yOffset}px`,
        opacity: 1
    };
    // Does the right side of the context menu overflow the window width, so move the menu left, positioning from the right
    if (xOffset + width + WINDOW_PADDING > globals.window.innerWidth) {
        delete styles.left;
        const contextRightFromLeftOfScreen = xOffset + width;
        const contextRightFromRightOfScreen = globals.window.innerWidth - contextRightFromLeftOfScreen;
        // It must be at least WINDOW_PADDING from the right
        const rightPosition = Math.max(contextRightFromRightOfScreen, WINDOW_PADDING);
        // @ts-ignore
        styles.right = `${rightPosition}px`;
    }
    // Does the bottom of the context menu overflow the bottom of the window, so move the menu up, positioning from the bottom
    if (yOffset + height + WINDOW_PADDING > globals.window.innerHeight) {
        delete styles.top;
        const contextBottomFromTopofScreen = yOffset + height;
        const contextBottomFromBottomOfScreen = globals.window.innerHeight - contextBottomFromTopofScreen;
        // It must be at least WINDOW_PADDING from the bottom
        const bottomPosition = Math.max(contextBottomFromBottomOfScreen, WINDOW_PADDING);
        // @ts-ignore
        styles.bottom = `${bottomPosition}px`;
    }
    return styles;
}
function SignInButton({ signInButtonText }) {
    return (React.createElement("music-button", { variant: "solid", href: "/forceSignIn?useHorizonte=true", id: "signInButton", style: { width: 'calc(100% - 20px)', margin: '0 10px' } }, signInButtonText));
}
export default function ContextMenuOverlay() {
    useStyles(Styles);
    const { open, options, xOffset, yOffset, refinement, hover, header, label, showSignInButton, signInButtonText } = useSelector((state) => state.ContextMenu);
    const [positionStyles, setPositionStyles] = useState({ opacity: 0 });
    const [resized, setResized] = useState(0);
    const contextMenu = useRef(null);
    const dispatch = useDispatch();
    const closeContextMenu = () => {
        dispatch({ type: CLOSE_CONTEXT_MENU });
    };
    // Recompute layout based on context menu size after each context row item renders
    // TODO: Only do once after all render
    const onComponentDidRender = () => {
        var _a, _b, _c, _d;
        const menuHeight = (_b = (_a = contextMenu) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.offsetHeight;
        const menuWidth = (_d = (_c = contextMenu) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.offsetWidth;
        setPositionStyles(computeStyle(xOffset, yOffset, menuWidth, menuHeight));
    };
    const handleOnMouseLeave = (event) => {
        var _a, _b, _c, _d;
        if (((_b = (_a = event) === null || _a === void 0 ? void 0 : _a.toElement) === null || _b === void 0 ? void 0 : _b.id) !== CONTEXT_MENU_HOVER_BUTTON_ID && ((_d = (_c = event) === null || _c === void 0 ? void 0 : _c.relatedTarget) === null || _d === void 0 ? void 0 : _d.id) !== CONTEXT_MENU_HOVER_BUTTON_ID) {
            closeContextMenu();
        }
    };
    const hoverProps = (isRefContextMenu) => {
        var _a, _b;
        if (positionStyles.right) {
            const menuWidth = ((_b = (_a = contextMenu) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0;
            positionStyles.left = `calc(100% - ${positionStyles.right} - ${menuWidth}px)`;
            delete positionStyles.right;
        }
        return hover ? { onMouseLeave: handleOnMouseLeave, id: CONTEXT_MENU_OVERLAY_ID, style: isRefContextMenu ? {} : positionStyles } :
            (isRefContextMenu ? { style: positionStyles } : { id: CONTEXT_MENU_OVERLAY_ID });
    };
    return open ? (React.createElement("div", Object.assign({ className: open ? Styles.modal : Styles.hidden, role: "dialog", "aria-modal": "true", "aria-labelledby": "dialogHeader", "aria-describedby": "dialogBodyText", onClick: closeContextMenu }, hoverProps(false)),
        React.createElement("div", Object.assign({ className: Styles.modalContent, ref: contextMenu }, hoverProps(true)),
            header && React.createElement("music-context-menu-header", { primaryText: header, labelText: label }),
            showSignInButton && React.createElement(SignInButton, { signInButtonText: signInButtonText }),
            options.map((option, idx) => (React.createElement(ContextMenuItem, { data: option, refinement: refinement, index: idx, onContextMenuRender: onComponentDidRender, closeContextMenu: closeContextMenu, link: option.link })))))) : null;
}
